<template>
  <div class="us-nav-wrap">
    <div class="us-nav-inner">
      <div class="left" @click="onGo('home')">
        <img class="logo" src="/static/logo1.png" alt="">
      </div>
      <div class="right">
        <div class="time-wrap">
          <div class="time-full">{{ timeFull }}</div>
          <div class="time-week">{{ timeWeek }}</div>
          <div v-if="this.language == 'zh'" class="time-lunar">{{ lunnarStr }}</div>
        </div>
        <div class="nav-right">
          <!-- <template v-if="currentMenuNameReal != 'search'"> -->
          <template>
            <div class="search-wrap">
              <el-input 
                class="search-input"
                v-model="searchStr"
                size="mini" 
                prefix-icon="el-icon-search"
                :placeholder="$t('common.search')"
                @keyup.native.enter="onSearch"/>
            </div>
            <div class="search-fold" @click="miniSearchInpuShow = !miniSearchInpuShow">
              <img src="@/assets/icons/search.png">
            </div>
          </template>
          <!-- 多语言-先注释 -->
          <!-- <div class="lang-wrap">
            <el-popover
              placement="bottom"
              width="80">
              <div slot="reference" class="lang-selecor">
                <img class="icon-p" src="/static/img/icon/lang.png">
                <div class="lang-inner">{{ currentLangName }}</div>
                <i class="el-icon-arrow-down"></i>
              </div>
              <div class="lang-list">
                <div 
                  v-for="(item,index) in getLangList" 
                  :key="index" 
                  class="lang-item"
                  :class="{active: item.key == language}"
                  @click="onChangeLang(item.key)">{{ item.name }}</div>
              </div>
            </el-popover>
          </div> -->
          <!-- 理事名作 -->
          <div v-if="currentMenuNameReal != 'council_composition'" class="nav-menu" @click="onGo('council_composition')">{{ $t('menu.council_composition') }}</div>
        </div>
      </div>
    </div>
    <!-- 搜索框 -->
    <div v-if="currentMenuNameReal != 'search'" class="mini-search-input-wrap" :class="{ show: miniSearchInpuShow }">
      <el-input 
        class="search-input"
        v-model="searchStr"
        size="mini" 
        prefix-icon="el-icon-search"
        :placeholder="$t('common.search')"/>
      <el-button class="search-btn" size="mini" @click="onSearch">{{ $t('common.search') }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
// import Menu from './Menu'
import { getLunarStr } from '@/utils/lunar'

export default {
  name: 'nav-bar',
  // components: { Menu },
  data() {
    return {
      language: "",
      showMidMenu: false,
      timeFull: '',
      timeWeek: '',
      lunnarStr: '',
      // 搜索
      searchStr: '',
      miniSearchInpuShow: false,
    }
  },
  computed: {
    ...mapGetters([
      'getLangList',
    ]),
    currentLangName() {
      return this.getLangList.find(item => item.key == this.language)?.name || '-';
    },
    currentMenuNameReal() {
      return this.$route.name;
    },
  },
  mounted() {
    const lang = localStorage.getItem("guangdong_lan_locale") || "zh";
    this.onSaveLang(lang)
    this.initTtme()
  },
  methods: {
    ...mapActions({
      actionIndexArticles: 'indexArticles',
    }),
    initTtme() {
      const now = new Date();
      const y = now.getFullYear();
      const m = this.$t(`common.month.m${now.getMonth() + 1}`);
      const d = now.getDate();
      const w = now.getDay();
      this.timeFull = this.$t(`common.time_full`, { y: y, m: m, d: d });
      this.timeWeek = this.$t(`common.week.w${w}`);
      this.lunnarStr = getLunarStr(now);
    },
    onSaveLang(lang) {
      localStorage.setItem("guangdong_lan_locale", lang);
      this.$i18n.locale = lang;
      this.language = lang;
    },
    onChangeLang(lang) {
      this.onSaveLang(lang)
      window.location.reload();
    },
    onGo(tag) {
      if (this.$route.name != tag) {
        this.$router.push(`/${tag}`)
      }
    },
    async onSearch() {
      if (!this.searchStr) {
        return
      }
      const ret = await this.actionIndexArticles(Object.assign({
        // tag: 'wenhuayaowen',
        // begin_time: this.timeList[this.currentTimeIndex].begin_time,
        // end_time: this.timeList[this.currentTimeIndex].end_time,
        content: this.searchStr,
      }))
      if (ret.code === 200) {
        const { rows, total } = ret.data
        if (total == 0) {
          alert(this.$t('common.search_empty'))
        } else {
          if (this.$route.name == 'search') {
            window.location.href = `/search?s=${encodeURIComponent(this.searchStr)}`;
          } else {
            this.$router.push(`/search?s=${encodeURIComponent(this.searchStr)}`)
          }
          this.searchStr = "";
        }
      }
    },
  }
}
</script>
<style lang="less">
.el-popover {
  padding: 0;
  border: none;
  .lang-list {
    border-radius: 4px;
    overflow: hidden;
  }
  .lang-item {
    padding: 6px 12px;
    cursor: pointer;
    &.active {
      background: rgba(@themeColor1, 1);
      color: #fff;
    }
    &:hover {
      background: rgba(@themeColor1, .7);
      color: #fff;
    }
  }
}
</style>
<style lang="less" scoped>
.us-nav-wrap {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 999;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  height: @navHeight;
  overflow: visible;
  // background: #A39474;

  .us-nav-inner {
    width: auto;
    max-width: @pageContentWidth;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    height: 100%;
    .left {
      height: 100%;
      .logo {
        height: 100%;
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
    }
    .time-wrap {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #643D20;
      // color: rgba(#ffffff, .9);
    }
    .nav-right {
      display: flex;
      align-items: center;
      gap: 16px;
      .search-fold {
        width: 30px;
        height: 30px;
        border-radius: 16px;
        display: none;
        align-items: center;
        justify-content: center;
        background: rgba(@themeColor1, 1);
        cursor: pointer;
        img {
          width: 16px;
        }
      }
      .search-wrap {
        width: 240px;
        height: 38px;
        border-radius: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(#724216, .6);
        cursor: pointer;
        :deep {
          .search-input {
            .el-input__inner {
              border-radius: 14px;
              background: transparent;
              border: none;
              color: #fff;
              font-size: 14px;
            }
          }
        }
      }
      .lang-wrap {
        cursor: pointer;
        .lang-selecor {
          padding: 0 16px;
          padding-right: 12px;
          display: flex;
          align-items: center;
          height: 38px;
          line-height: 38px;
          gap: 10px;
          // height: 28px;
          border-radius: 19px;
          // background: rgba(@themeColor1, 1);
          background: rgba(#724216, .6);
          letter-spacing: 1px;
        }
      }
      .nav-menu {
        height: 38px;
        line-height: 38px;
        text-align: center;
        padding: 0 24px;
        border-radius: 4px;
        // background: rgba(@themeColor1, 1);
        background: rgba(#724216, .6);
        color: #fff;
        letter-spacing: 2px;
        cursor: pointer;
        user-select: none;
        &:active {
          background: rgba(@themeColor1, .9);
        }
      }
    }
  }
  .mini-search-input-wrap {
    width: 100%;
    height: 0px;
    background: rgba(#724216, .6);
    transition: all .3s;
    display: none;
    align-items: center;
    gap: 16px;
    overflow: hidden;
    padding: 0 16px;
    &.show {
      height: 70px;
    }
    :deep {
      .search-input {
        .el-input__inner {
          border-radius: 14px;
          background: rgba(#724216, .8);
          // background: transparent;
          border: none;
          color: #fff;
        }
      }
      .search-btn {
        background: rgba(#724216, .8);
        color: #fff;
        border: none;

      }
    }
  }
}

@media screen and (max-width: @pageContentWidth) {
.us-nav-wrap {
  .us-nav-inner {
    width: 100vw;
    padding: 0 12px;
    margin: 0;
    .time-wrap {
      .time-week {
        display: none;
      }
      .time-lunar {
        display: none;
      }
    }
  }
}
}
@media screen and (max-width: @mdW) {
.us-nav-wrap {
  background: @themeColor3;
  height: @navMHeight;
  .us-nav-inner {
    width: 100vw;
    padding: 0 12px;
    margin: 0;
    justify-content: space-between;
    .left {
      display: none;
    }
    .right {
      flex: 1;
      justify-content: space-between;
    }
    .time-wrap {
      gap: 4px;
      .time-week {
        display: none;
      }
      .time-lunar {
        display: none;
      }
    }
    .nav-right {
      gap: 12px;
      .search-wrap {
        display: none;
      }
      .search-fold {
        display: flex;
      }
      .nav-menu {
        display: none;
      }
    }
  }
  .mini-search-input-wrap {
    display: flex;
  }
}
}
</style>
